// src/pages/News/CreateNewsModal.jsx
import React, { useState, useEffect } from "react";
import { FaSave, FaTimes } from "react-icons/fa";
import Button from "./../../components/Button/Button";
import { useUser } from "./../../contexts/UserContext";
import { toast } from "react-toastify";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const CreateNewsModal = ({ isOpen, onClose, onCreateSuccess }) => {
  const { user } = useUser();

  const [formData, setFormData] = useState({
    title: "",
    content: "",
    image_url: "",
    author_id: user?.userId || "",
    is_active: true,
    destinataires_news: "Tout public",
  });

  useEffect(() => {
    if (isOpen) {
      setFormData((prev) => ({
        ...prev,
        author_id: user?.userId || "",
      }));
    }
  }, [isOpen, user]);

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleContentChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      content: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await onCreateSuccess(formData);
      setFormData({
        title: "",
        content: "",
        image_url: "",
        author_id: user?.userId || "",
        is_active: true,
        destinataires_news: "Tout public",
      });
      onClose();
    } catch (error) {
      console.error("Erreur lors de la création de l'actualité", error);
      toast.error("Erreur lors de la création de l'actualité.");
    }
  };

  const handleCancel = () => {
    setFormData({
      title: "",
      content: "",
      image_url: "",
      author_id: user?.userId || "",
      is_active: true,
      destinataires_news: "Tout public",
    });
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex justify-center items-center z-50">
      <div className="w-full max-w-3xl bg-white dark:bg-slate-900 rounded-2xl shadow-2xl overflow-hidden">
        <div className="bg-gradient-to-r from-primary via-indigo-500 to-cyan-500 px-5 py-3 flex items-center justify-between">
          <h3 className="text-lg md:text-xl font-bold uppercase text-white tracking-[0.18em]">
            Créer une actualité
          </h3>
          <button
            type="button"
            onClick={onClose}
            className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-black/40 text-white hover:bg-black/70"
          >
            <FaTimes />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-4 md:p-5 space-y-4">
          <div>
            <label className="block text-xs font-semibold uppercase tracking-[0.18em] mb-1 text-slate-600 dark:text-slate-300">
              Titre de l&apos;actualité
            </label>
            <input
              type="text"
              name="title"
              placeholder="Ex : Résultats Coupe de Gironde Minimes..."
              value={formData.title}
              onChange={handleChange}
              className="input input-bordered w-full dark:bg-slate-800 dark:border-slate-700 dark:text-white"
              required
            />
          </div>

          <div>
            <label className="block text-xs font-semibold uppercase tracking-[0.18em] mb-1 text-slate-600 dark:text-slate-300">
              Contenu
            </label>
            <div className="rounded-lg overflow-hidden border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800">
              <ReactQuill value={formData.content} onChange={handleContentChange} />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-xs font-semibold uppercase tracking-[0.18em] mb-1 text-slate-600 dark:text-slate-300">
                URL de l&apos;image
              </label>
              <input
                type="url"
                name="image_url"
                placeholder="https://..."
                value={formData.image_url}
                onChange={handleChange}
                className="input input-bordered w-full dark:bg-slate-800 dark:border-slate-700 dark:text-white"
              />
            </div>

            <div>
              <label className="block text-xs font-semibold uppercase tracking-[0.18em] mb-1 text-slate-600 dark:text-slate-300">
                Destinataires
              </label>
              <select
                name="destinataires_news"
                value={formData.destinataires_news}
                onChange={handleChange}
                className="select select-bordered w-full dark:bg-slate-800 dark:border-slate-700 dark:text-white"
              >
                <option value="Tout public">Tout public</option>
                <option value="Acteurs du Judo girondin">
                  Acteurs du Judo girondin
                </option>
                <option value="Membres du Comité">Membres du Comité</option>
              </select>
            </div>
          </div>

          <label className="flex items-center gap-2 text-sm text-slate-700 dark:text-slate-200">
            <input
              type="checkbox"
              name="is_active"
              checked={formData.is_active}
              onChange={handleChange}
              className="checkbox checkbox-primary"
            />
            <span>Actualité active (visible sur le site public)</span>
          </label>

          <div className="flex justify-center gap-3 pt-2">
            <Button
              text="Enregistrer"
              icon={FaSave}
              type="submit"
              className="gap-2"
            />
            <Button
              text="Annuler"
              icon={FaTimes}
              type="button"
              onClick={handleCancel}
              className="gap-2 btn-ghost"
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateNewsModal;
